import { Post } from 'model';
import { FormValidationRules } from '../hooks/useFormValues';

export const MarketplaceItemEditRules: FormValidationRules<Post> = {
	topic: {
		rules: {
			required: {
				value: true,
				message: 'Category is required'
			},
			maxLength: {
				value: 20,
				message: 'Must be less than {value} characters'
			},
			pattern: {
				value: /^\S*$/,
				message: 'Must be one word'
			}
		}
	},
	title: {
		rules: {
			required: {
				value: true,
				message: 'Item Offered is required'
			},
			maxLength: {
				value: 80,
				message: 'Must be less than {value} characters'
			},
			minLength: {
				value: 10,
				message: 'Must be more than {value} characters'
			}
		}
	},
	price: {
		rules: {
			required: {
				value: true,
				message: 'Price is required'
			},
			min: {
				value: 0,
				message: "Price can't be less than zero"
			}
		}
	},
	contents: {
		rules: {
			maxLength: {
				value: 10000,
				message: 'Must be less than {value} characters'
			},
			required: {
				value: true,
				message: 'Item Description is required'
			}
		}
	}
};
